var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,7.37h0A4.63,4.63,0,1,0,16.63,12,4.64,4.64,0,0,0,12,7.37Zm0,7.17a2.54,2.54,0,0,1-.33-5.06,2,2,0,0,0,.54,1.65,2,2,0,0,0,2.29.39,2.59,2.59,0,0,1,0,.48A2.54,2.54,0,0,1,12,14.54Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.85,11.61A10.56,10.56,0,0,0,12,5h0a10.56,10.56,0,0,0-9.85,6.57L2,12l.15.39a10.68,10.68,0,0,0,13.71,5.85,10.51,10.51,0,0,0,6-5.85L22,12Zm-6.73,4.7A8.6,8.6,0,0,1,4.24,12,8.48,8.48,0,0,1,12,7.11,8.47,8.47,0,0,1,19.76,12,8.46,8.46,0,0,1,15.12,16.31Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.d721b7b7313e5b31692ac58596d2a324.svg";
export { ForwardRef as ReactComponent };